export enum EndConsultantRequestStatus {
  NotDefined = -1,
  Pending = 0,
  InNegotiation = 1,
  Rejected = 2,
  Cancelled = 3,
  Accepted = 4,
}
